import type { ReactNode } from "react";
import "./ComponentCard.scss";

type ComponentCardProps = {
  title: string;
  children: ReactNode;
};

const ComponentCard = ({ title, children }: ComponentCardProps) => (
  <article className="component-card">
    <h3 className="component-card__title">{title}</h3>
    <div className="component-card__preview">{children}</div>
  </article>
);

export default ComponentCard;
